/**
 * ported from redux-notifications
 */
import { useDispatch, useSelector } from 'react-redux';
import { notifDismiss } from '../../actions/notifications';
import Notification from '../../molecules/Notification';
import { IStore } from '../../reducers';

import './styles.scss';

const Notifs = () => {
  const notifications = useSelector((state: IStore) => state.notifs);
  const dispatch = useDispatch();

  const onClose = (id: number) => dispatch(notifDismiss(id));

  return (
    <div className='notif__container'>
      {notifications.map((notif) => {
        return (
          <Notification
            key={notif.id}
            data={notif}
            onClose={() => onClose(notif.id)}
          />
        );
      })}
    </div>
  );
};

export default Notifs;
